<header id="page-topbar" (window:scroll)="windowScroll()">
    <div class="layout-width">
        <div class="navbar-header">
            <div class="d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box horizontal-logo">
                    <a routerLink="/" class="logo logo-dark">
                        <span class="logo-sm">
                            <img src="assets/images/logo-sm.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/logo-dark.png" alt="" height="22">
                        </span>
                    </a>

                    <a routerLink="/" class="logo logo-light">
                        <span class="logo-sm">
                            <img src="assets/images/logo-sm.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/logo-light.png" alt="" height="22">
                        </span>
                    </a>
                </div>

                <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
                    <span class="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>

                <div class="companyDetails">
                    <!-- <img src="../../../assets/images/CLogo.png" alt="CompanyLogo"> -->
                    <span class="companyName">{{this.currentuser.companyName}}</span>
                </div>
            </div>

            <div class="d-flex align-items-center leftGap">
                <div class="ms-1 header-item d-none d-sm-flex">
                    <button type="button" class="btn btn-icon btn-topbar btn-ghost-dark rounded-circle" data-toggle="fullscreen" (click)="fullscreen()">
                        <i class="bi bi-arrows-fullscreen fs-lg"></i>
                    </button>
                </div>

                <div dropdown class="dropdown topbar-head-dropdown ms-1 header-item" id="notificationDropdown">
                    <button dropdownToggle type="button" class="btn btn-icon btn-topbar btn-ghost-dark rounded-circle" id="page-header-notifications-dropdown" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
                        <i class='bi bi-briefcase fs-2xl'></i>
                        <span class="position-absolute topbar-badge fs-3xs translate-middle badge rounded-pill bg-danger"><span class="notification-badge">{{totalTasksNumber}}</span><span class="visually-hidden">unread messages</span></span>
                    </button>
                    <div *dropdownMenu class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-notifications-dropdown">

                        <div *ngIf="totalTasksNumber !== 0" class="dropdown-head rounded-top dropdown-body" style="max-height: 400px; overflow-y: auto;text-align: right;">
                            <div class="p-3 border-bottom border-bottom-dashed divCon"  *ngFor="let task of tasks" (click)="goToDeatils(task.recordID, task.processActionId, task.excutedProcessID, task.dataURL)">
                                <div class="taskDiv">
                                    <span class="taskTitle">{{task.name}}</span>
                                    <span style="color: #a9a6a6;">{{'fromDateTask' | translate}} : {{task.createDate | date: 'dd/MM/YYYY'}}</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="totalTasksNumber !== 0" class="notificationFooter" routerLink="/all-tasks">
                            <span>{{'showAllTasks' | translate}}</span>
                        </div>

                        <div *ngIf="totalTasksNumber === 0" class="dropdown-head rounded-top dropdown-body" style="max-height: 400px; overflow-y: auto;text-align: right;">
                            <div class="notificationFooter">
                                <span>{{'NoTasks' | translate}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div dropdown class="dropdown topbar-head-dropdown ms-1 header-item" id="notificationDropdown">
                    <button dropdownToggle type="button" class="btn btn-icon btn-topbar btn-ghost-dark rounded-circle" id="page-header-notifications-dropdown" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
                        <i class='bi bi-bell fs-2xl'></i>
                        <span class="position-absolute topbar-badge fs-3xs translate-middle badge rounded-pill bg-danger"><span class="notification-badge">{{totalNotificationsNumber}}</span><span class="visually-hidden">unread messages</span></span>
                    </button>
                    <div *dropdownMenu class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-notifications-dropdown" style="border: none;">

                        <div *ngIf="totalNotificationsNumber !== 0" class="dropdown-head rounded-top dropdown-body" style="max-height: 400px; overflow-y: auto;text-align: right;">
                            <div class="p-3 border-bottom border-bottom-dashed divCon"  *ngFor="let notification of notifications">
                                <div class="taskDiv">
                                    <span class="taskTitle">{{'agreed' | translate}} {{notification.describtion}}</span>
                                    <span style="color: #a9a6a6;">{{'fromDateTask' | translate}} : {{notification.createDate | date: 'dd/MM/YYYY'}}</span>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="totalNotificationsNumber === 0" class="dropdown-head rounded-top dropdown-body" style="max-height: 400px; overflow-y: auto;text-align: right;">
                            <div class="notificationFooter">
                                <span>{{'NoNotifications' | translate}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div dropdown class="dropdown ms-sm-3 header-item topbar-user">

                    <div dropdownToggle class="profile" id="page-header-user-dropdown" id="page-header-auth-dropdown" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false" [class.spinner]="loadingUserData">
                        <img class="rounded-circle header-profile-user"
                        [src]="currentuser.empId === 0 ? (user?.personalImg ? baseService.imgUrl + user.personalImg : 'assets/images/Avatar.png') : (employee?.photo ? baseService.imgUrl + employee.photo : 'assets/images/Avatar.png')" (error)="onImgError($event)"
                        alt="profilepicplaceholder">
                        <span *ngIf="this.currentuser.empId === 0" class="accountName">{{this.user.name}}</span>
                        <span *ngIf="this.currentuser.empId !== 0" class="accountName">{{this.employee.personalEmail}}</span>
                        <i class="ph-caret-down"></i>
                    </div>

                    <div *dropdownMenu class="dropdown-menu dropdown-menu-end  p-0" aria-labelledby="page-header-auth-dropdown">
                        <div class="dropdown-head  rounded-top">
                            <div class="p-3 border-bottom border-bottom-dashed" style="display: flex;flex-direction: column;gap: 10px;">
                                <a class="dropdown-item" (click)="goToProfile()"><i class="ph-user"></i> <span class="align-middle">{{'profile' | translate}}</span></a>
                                <a class="dropdown-item logoutItem" (click)="logout()"><i class="ph-sign-out"></i> <span class="align-middle">{{'logout' | translate}}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>